import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { SharedService } from '../shared/shared.service';
import { AppState } from '../../app.reducer';
import * as selectors from '../audits/audits.selectors';
import { AuditAction } from './audits.actions';
import { Observable } from 'rxjs';
import { List } from 'immutable';

@Injectable()
export class AuditService extends SharedService {

    public constructor(protected store: Store<AppState>, protected action: AuditAction) {
        super(store, action, selectors);
    }

    public loadByIds(type: string, ids: string[], fromDate?: number, toDate?: number, limit?: number) {
      this.store.dispatch(this.action.load(type, ids, fromDate, toDate, limit));
    }

    public getHistory(requestObj: any) {
      this.store.dispatch(this.action.loadHistory(requestObj));
    }

    public clearHistory() {
      this.store.dispatch(this.action.clearHistory());
    }

    public getAllHistory(): Observable<any> {
      return this.getAPIState().let(this.selectors.getHistory());
    }
}
